<template>
  <section id="tasklist">
    <main style="text-align:left;white-space:normal">
      <div class="title">
        <span>
          <icon icoClass='title-ico' selected='tasklist'/>
          {{$t('task_list')}}
        </span>
        <button class="btn-blue btn-small" @click="showAddTask=true;">
          {{ $t('add_task') }}
        </button>
        <button class="btn-green btn-small" @click="downloadExcel()">
          {{ $t('export_excel') }}
        </button>
      </div>
      <div id="filters">
        <div>
          <div class="field">
            <label>{{ $t("from") }}</label>
            <input
              type="date"
              v-model="filters.date_after"
              @change="fillPage(1)"
            />
          </div>
          <div class="field">
            <label>{{ $t("to") }}</label>
            <input
              type="date"
              v-model="filters.date_before"
              @change="fillPage(1)"
            />
          </div>
          <div class="field">
            <label>{{ $t("user") }}</label>
            <search-select inputStyle="box-sizing: border-box" url="user" field="user.first_name" field2="user.last_name" searchField="user" divStyle="width: 100%; box-sizing: border-box; display: inline-block" @data="filters.user=$event;fillPage(1)" :source="filters.user" />
          </div>
          <div class="field">
            <label>{{ $t("task") }}</label>
            <search-select inputStyle="box-sizing: border-box" url="worksheet" field="name" searchField="worksheet" divStyle="width: 100%; box-sizing: border-box; display: inline-block" @data="filters.worksheet=$event;fillPage(1)" :source="filters.worksheet" />
          </div>
        </div>
        <date-filter
          @update="
            $set(filters, 'date_before', $event.before);
            $set(filters, 'date_after', $event.after);
            fillPage(1)
          "
          :options="['yesterday', 'today', 'tomorrow']"
          :before="filters.date_before"
          :after="filters.date_after"
          @reset="
            filters = {};
            fillPage(1);
          "
        />
      </div>
      <div class="box-table">
      <table class="table first" v-for="(value, key) in this.readOnlyTask" :key="key" style="margin-top:1em">
          <thead class="table-header" style="padding: 5px; border-collapse: collapse;">
            <th style="display: flex;">
              <div class="field" style="width:100%; box-sizing: border-box; padding: .5em">
                  <label>{{ value.task }}</label>
              </div>
              <div class="icon-add">
                <a class="icon-add-link" @click="showLineTask=true; line={}; line.worksheet={id: value.taskId, name: value.task}">
                  <i class="fas fa-plus" />
                </a>
              </div>
            </th>
          </thead>
          <div class="space"></div>
          <tbody class="table-body">
            <tr>
              <td class="line-none">
                <table class="table sub-table">
                  <thead class="subtable">
                    <th v-if="!filters.user">
                      <div class="field" style="width:100%; box-sizing: border-box;">
                          <label>{{$t('user')}}</label>
                      </div>
                    </th>
                    <th>
                      <label>{{$t('client')}}</label>
                    </th>
                    <th >
                      <label>{{$t('description')}}</label>
                    </th>
                    <th>
                      <label>{{$t('reference')}}</label>
                    </th>
                    <th>
                      <label>{{$t('n_tags')}}</label>
                    </th>
                    <th>
                      <label>{{$t('reviews')}}</label>
                    </th>
                    <th>
                      <label>{{$t('pieces_ok')}}</label>
                    </th>
                    <th>
                      <label>{{$t('rework')}}</label>
                    </th>
                    <th>
                      <label>{{$t('pieces_nok')}}</label>
                    </th>
                    <th>
                      <label>{{$t('hours')}}</label>
                    </th>
                    <th>
                      <label>{{$t('observations')}}</label>
                    </th>
                    <th>
                      <label>{{$t('actions')}}</label>
                    </th>
                  </thead>
                  <tbody>
                    <tr v-for="(taskline, index) in value.objs" :key="index">
                      <template>
                        <td v-if="!filters.user">
                          <div class="field">
                            <span class="custom-dropdown" style="width:100%; box-sizing: border-box">
                                <select disabled>
                                    <option>{{ taskline.user.user.first_name }} {{ taskline.user.user.last_name }}</option>
                                </select>
                            </span>

                            <div  class="base-input" style="width:100%; box-sizing: border-box"></div>
                          </div>
                        </td>
                        <td>
                          <input type="text"  style="width: 100%; box-sizing: border-box" v-model="taskline.client.description" disabled />
                        </td>
                        <td>
                          <input type="text"  style="box-sizing: border-box" v-model="taskline.description.name" disabled />
                        </td>
                        <td>
                          <input type="text"  style="width:100%; box-sizing: border-box" v-model="taskline.reference" disabled />
                        </td>
                        <td>
                          <input type="text"  style="width:100%; box-sizing: border-box" v-model="taskline.tag_number" disabled />
                        </td>
                        <td>
                          <input type="text"  style="width: 100%; box-sizing: border-box" v-model="taskline.reviewed_parts" disabled />
                        </td>
                        <td>
                          <input type="text"  style="width: 100%; box-sizing: border-box" v-model="taskline.right_parts" disabled />
                        </td>
                        <td>
                          <input type="text"  style="width: 100%;box-sizing: border-box" v-model="taskline.reworked_parts" disabled />
                        </td>
                        <td>
                          <input type="text"  style="width: 100%; box-sizing: border-box" v-model="taskline.nok_parts" disabled />
                        </td>
                        <td>
                            <input type="number"  style="width: 100%; box-sizing: border-box" v-model="taskline.time_hours" disabled/>
                        </td>
                        <td>
                          <input type="text"  style=" box-sizing: border-box" v-model="taskline.observations" disabled/>
                        </td>
                        <td>
                          <div style="padding-left:0.4em; font-size:1.5em; ">
                            <a :title="$t('detail')" @click="line=taskline; showLineTask=true;">
                              <misc-icon icoClass='title-ico' selected='edit'/>
                            </a>
                            <a :title="$t('delete')" @click="line=taskline; showDelete=true">
                              <misc-icon icoClass='title-ico' selected='delete' :title="$t('delete')"/>
                            </a>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <div id="pages">
          <div class="move-page" @click="page > 1 ? fillPage(page-1) : ''">
            «{{$t('prev')}}.
          </div>
          <div v-for="pageShown in pagesShown" :key="pageShown" :class="page===pageShown? 'selected-page': 'page'" @click="fillPage(pageShown)">
            {{pageShown}}
          </div>
          <div class="move-page" @click="page < count/pageSize ? fillPage(page+1) : ''">
            {{$t('next')}}.»
          </div>
        </div>
      </div>
      <modal v-if="showAddTask">
        <div slot="body">
          <div class="title">
            {{ $t("add_task") }}
          </div>
          <div class="field">
            <label>{{$t('name')}}<span class="mandatory">*</span><button class="btn-blue" @click="showCreateTask=true">{{$t("create_task")}}</button></label>
            <search-select inputStyle="box-sizing: border-box" url="worksheet" field="name" searchField="worksheet" divStyle="width: 100%; box-sizing: border-box;" @data="task=$event;fillPage(1)" :source="task" />
          </div>
          <div>
            <button class="btn-blue" @click="newTask=task;showAddTask = false; task={}"  style="margin-top:.5em; margin-left: .5em;">
            {{ $t("save") }}
            </button>
            <button class="btn-black" @click="showAddTask = false;">
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
      </modal>
      <modal v-if="showCreateTask">
        <div slot="body">
          <div class="title">
            {{ $t("create_task") }}
          </div>
          <div class="field" style="margin:.5em">
            <label>{{$t('name')}}<span class="mandatory">*</span></label>
            <input type="text" v-model="task.name" />
          </div>
          <div>
            <button class="btn-blue" @click="newCreateTask=task; saveTasks(); showCreateTask = false; task={}; fillPage(1);"  style="margin-top:.5em; margin-left: .5em;">
            {{ $t("save") }}
            </button>
            <button class="btn-black" @click="showCreateTask = false;">
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
      </modal>
      <modal v-if="showLineTask">
        <div slot="body" style="padding:.5em 1.5em;">
          <div class="title">
            {{ $t("add_line") }}
          </div>
          <div style="display: flex;">
            <div class="field" style="margin:.5em;">
              <label>{{$t('date')}}<span class="mandatory">*</span></label>
              <input type="date" style="width:12.5em; box-sizing: border-box" placeholder="dd/mm/yyyy" v-model="line.date" required />
            </div>
            <div class="field" style="margin:.5em">
              <label>{{$t('user')}}<span class="mandatory">*</span></label>
              <search-select inputStyle="box-sizing: border-box" url="user" field="user.first_name" field2="user.last_name" searchField="search" divStyle="width:100%;box-sizing: border-box; display: inline-block" @data="line.user=$event" :source="line.user" required />
            </div>
            <div class="field" style="margin:.5em">
              <label>{{$t('task')}}<span class="mandatory">*</span></label>
              <search-select inputStyle="box-sizing: border-box" url="worksheet" field="name" searchField="worksheet" divStyle="width: 100%; box-sizing: border-box; display: inline-block" @data="line.worksheet=$event;fillPage(1)" :source="line.worksheet" required />
            </div>
          </div>
          <div class="field" style="margin:.5em">
            <label>
              {{$t('description')}}<span class="mandatory">*</span>
              <button class="btn-blue" @click="showCreateDescriptionTask=true; newDescriptionTask.worksheet=line.worksheet.id">{{$t("add")}} {{ $t('description') }}</button>
            </label>
            <search-select inputStyle="box-sizing: border-box" url="work-description" field="name" :extraParams="{worksheet: line.worksheet.id}" divStyle="text-transform: uppercase;width: 100%; box-sizing: border-box; display: inline-block" @data="line.description=$event" :source="line.description" />
          </div>
          <div style="display: flex;">
            <div class="field" style="margin:.5em">
              <label>{{$t('reference')}}</label>
              <input type="text" v-model="line.reference" />
            </div>
            <div class="field" style="margin:.5em">
              <label>{{$t('n_tags')}}</label>
              <input type="text" v-model="line.tag_number" />
            </div>
            <div class="field" style="margin:.5em">
              <label>{{$t('hours')}}<span class="mandatory">*</span></label>
              <input type="number" v-model="line.time_hours" />
            </div>
          </div>
          <div class="field" style="margin:.5em">
            <label>{{$t('client')}}<span class="mandatory">*</span></label>
            <search-select inputStyle="box-sizing: border-box" url="client" field="description" divStyle="text-transform: uppercase;width: 100%; box-sizing: border-box; display: inline-block" @data="line.client=$event" :source="line.client" :listdata="userData.clients" />
          </div>
          <div style="display: flex;">
            <div class="field" style="margin:.5em;">
              <label>{{$t('reviews')}}</label>
              <input type="number" style="width: 100%;" v-model="line.reviewed_parts">
            </div>
            <div class="field" style="margin:.5em;">
              <label>{{$t('rework')}}</label>
              <input type="number" style="width: 100%;" v-model="line.reworked_parts">
            </div>
          </div>
            <div style="display: flex;">
              <div class="field" style="margin:.5em;">
                <label>{{$t('pieces_ok')}}</label>
                <input type="number" style="width: 100%;" v-model="line.right_parts">
              </div>
              <div class="field" style="margin:.5em;">
                <label>{{$t('pieces_nok')}}</label>
                <input type="number" style="width: 100%;" v-model="line.nok_parts">
              </div>
          </div>
          <div class="field" style="margin:.5em">
            <label>{{$t('observations')}}</label>
            <textarea v-model="line.observations" style="width: 98%"></textarea>
          </div>
          <button class="btn-blue" @click="save()" style="margin:.5em">
            {{ $t("save") }}
          </button>
          <button class="btn-black" @click="showLineTask=false; line={}">
            {{ $t("cancel") }}
          </button>
        </div>
      </modal>
      <modal v-if="showCreateDescriptionTask">
        <div slot="body">
          <div class="title">
            {{ $t("create_task") }} {{ $t('description') }}
          </div>
          <div class="field" style="margin:.5em">
            <label>{{$t('name')}}<span class="mandatory">*</span></label>
            <input type="text" v-model="newDescriptionTask.name" />
          </div>
          <div>
            <button class="btn-blue" @click="saveTasksDescription(); showCreateDescriptionTask=false"  style="margin-top:.5em; margin-left: .5em;">
            {{ $t("save") }}
            </button>
            <button class="btn-black" @click="showCreateDescriptionTask = false;">
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
      </modal>
      <modal v-if="showDelete">
        <div slot="body" class="delete-modal">
          {{ $t("delete_message") }}
          <div class="buttons">
            <button class="btn-green" @click="deleteLine(line)">
              {{ $t("ok") }}
            </button>
            <button class="btn-black" @click="showDelete = false; line = {}">
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
      </modal>
    </main>
  </section>
</template>

<script>
import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import icon from './../svg/tabs'
import miscIcon from './../svg/misc'
import modal from '../components/Modal.vue'
import {mapActions, mapState} from 'vuex'
import searchInput from '../components/SearchInput.vue'
import searchSelect from '../components/SearchSelect.vue'
import dateFilter from './../components/DateFilter'
export default {
  name: 'tasklist',
  components: {
    icon,
    miscIcon,
    modal,
    searchInput,
    searchSelect,
    dateFilter
  },
  mixins: [PaginatedFilteredListMixin],

  mounted () {
    if (this.$route.query && this.$route.query.shipment) {
      this.shipment = this.$route.query.shipment
      this.canSeeFilters = false
    }
    const promises = [
      this.fillPage(1)
    ]
    this.$emit('loaded')
    Promise.all(promises).then((data) => {
      this.$emit('loaded')
    })
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      company: state => state.auth.company
    }),
    pagesShown: {
      get: function () {
        var pages = [this.page]
        for (let index = 1; index <= 2; index++) {
          if (this.page - index > 0) {
            pages.push(this.page - index)
          }
          if (this.page + index <= Math.ceil(this.count / this.pageSize)) {
            pages.push(this.page + index)
          }
        }
        return pages.sort(function (a, b) {
          return a - b
        })
      }
    },
    readOnlyTask: {
      get: function () {
        var output = {}
        if (this.newTask && this.newTask.id) {
          if (!output[this.newTask]) {
            output[this.newTask.id] = {
              task: this.newTask.name,
              taskId: this.newTask.id,
              objs: []
            }
          }
        }
        for (let work of this.objects) {
          if (output[work.worksheet.id]) {
            output[work.worksheet.id].objs.push(work)
          } else {
            output[work.worksheet.id] = {
              task: work.worksheet.name,
              taskId: work.worksheet.id,
              objs: [work]
            }
          }
        }
        return output
      }
    }
  },
  data () {
    return {
      shipment: {},
      showAddTask: false,
      showDelete: false,
      showLineTask: false,
      tasks: [],
      task: {},
      objects: [],
      newTask: {},
      worktimes: [],
      line: {},
      filters: {},
      canSeeFilters: true,
      showCreateTask: false,
      lista: [],
      newCreateTask: {name: ''},
      showCreateDescriptionTask: false,
      newDescriptionTask: {name: '', worksheet: ''}
    }
  },
  methods: {
    ...mapActions({
      getObjects: 'tasks/list',
      deleteTaskLine: 'tasks/delete',
      getWorktime: 'tasks/listWorktimes',
      saveLineTask: 'tasks/saveLine',
      exportExcel: 'tasks/export',
      saveTask: 'tasks/save',
      saveTaskDescription: 'tasks/saveDescription'
    }),
    deleteLine (line) {
      this.deleteTaskLine(line.id).then(() => {
        this.fillPage(this.page)
        this.showDelete = false
      })
    },
    fillPage (page) {
      var filters = Object.assign(
        {},
        { page: page, page_size: this.pageSize },
        this.filters
      )
      if (filters.user && filters.user.user.id) {
        filters.user = filters.user.user.id
      }
      if (filters.worksheet && filters.worksheet.id) {
        filters.worksheet = filters.worksheet.id
      }
      this.filters = filters
      this.getPage(page)
    },
    downloadExcel () {
      this.exportExcel(this.filters).then(() => {})
    },
    save () {
      if (!this.line.task && this.newTask) {
        this.line.task = this.newTask
      }
      if (!this.line.company) {
        this.line.company = this.company
      }
      var taskSave = Object.assign({}, this.line)
      Object.keys(taskSave).forEach(key => {
        if (taskSave[key] && (taskSave[key].id)) {
          taskSave[key] = taskSave[key].id
        }
        if (taskSave[key] && taskSave[key]['user']) {
          taskSave[key] = taskSave[key]['user'].id
        }
      })
      this.saveLineTask(taskSave).then(response => {
        this.showLineTask = false
        taskSave = {}
        this.objects = []
        this.fillPage(1)
        this.$emit('save', response)
      })
    },
    saveTasks () {
      if (!this.newCreateTask.name) {
        this.$notify({ group: 'global', duration: 4000, title: 'ERROR', type: 'error', text: this.$t('empty', { field: this.$t('name') }) })
        return
      }
      if (!this.newCreateTask.company) {
        this.newCreateTask.company = this.company
      }
      this.saveTask(this.newCreateTask).then(response => {
        this.showCreateTask = false
        this.newCreateTask = {}
        this.fillPage(1)
        this.$emit('save', response)
      })
    },
    saveTasksDescription () {
      if (!this.newDescriptionTask.name) {
        this.$notify({ group: 'global', duration: 4000, title: 'ERROR', type: 'error', text: this.$t('empty', { field: this.$t('name') }) })
        return
      }
      this.saveTaskDescription(this.newDescriptionTask).then(response => {
        this.newDescriptionTask = {}
        this.fillPage(1)
        this.$emit('save', response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.field {
  margin: 0;
}

.input-factors-table {
  border: none;
  &:focus {
    outline: none;
  }
}
.table .table-header {
    background: #c9d70a;
    padding-bottom: 0.4em;
    font-size: 1em;
    font-family: MuseoSans-300;
    text-transform: uppercase;
}
.first {
  thead {
    width: 100%;
  }
  tbody {
    max-height: 50em;
    tr {
      width: calc(100% - .15em);
    }
  }
}

.table {
  margin: 0;
  min-width: 100%;
}
.subtable {
  // background-color: $k-turq!important;
  background-color: transparent !important;
  // color: white;
  font-weight: bold;
  border-collapse: collapse;

  th {
    padding: .3em;
    text-transform: uppercase;
    font-family: MuseoSans-900;
  }
}

.icon-add {
  text-align: end;
  line-height: 2em;
  margin-right: 10px;
  &:hover .tooltip-one {
    display: block;
  }
}

.title-modal {
  margin: 1em;
  color: $k-turq;
  font-weight: bold;
}
.form .input-group .text-form {
  min-width: 4em;
}
form .input-group .form-input {
    flex: 2;
    min-width: 20em;
}
.select-title {
  margin-left: -2.4em;
}
.empty-input-group {
  min-width: 32em;
}
.sub-table {
  margin-top: 0.5em!important;
}
.line-none {
  border-top: none !important;
  border-right: none !important;
  border-left: none !important;
  padding: 0em !important;
  thead > td {
    border: none!important;
  }
}

input[type="datetime-local"] {
  padding: 0.2em;
}
.custom-dropdown select {
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageTaskList.vue